function formatFinancial(x) {
  return Number.parseFloat(x).toFixed(2);
}

export default formatFinancial;
